import { FC } from 'react';

export const Flag: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6 2C6.55228 2 7 2.44772 7 3V4H20C20.3635 4 20.6984 4.19728 20.8746 4.51523C21.0509 4.83319 21.0407 5.22173 20.848 5.53L18.6792 9L20.848 12.47C21.0407 12.7783 21.0509 13.1668 20.8746 13.4848C20.6984 13.8027 20.3635 14 20 14H7V21C7 21.5523 6.55228 22 6 22C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2ZM7 12H18.1958L16.652 9.53C16.4493 9.20573 16.4493 8.79427 16.652 8.47L18.1958 6H7V12Z"
			fill="currentColor"
		/>
	</svg>
);
